export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "/api";

export const ADMIN_API_BASE_URL = `${API_BASE_URL}/admin`;

// Sidebar altindaki "Sirket Araclari" baglantilari. Production'da her ortamda
// dogrudan URL'ye ihtiyac oldugu icin env variable'lar araciligiyla override
// edilebilir. Fallback'ler mevcut kurulumdaki intranet IP'leridir.
export const EXTERNAL_TOOLS = Object.freeze({
  tools:
    process.env.REACT_APP_TOOLS_URL || "http://192.168.10.4:24100",
  cms:
    process.env.REACT_APP_CMS_URL || "http://192.168.10.4:4001",
  gitlabEditor:
    process.env.REACT_APP_GITLAB_EDITOR_URL || "http://192.168.10.4:8088",
});
